import { differenceInSeconds } from 'date-fns';
import { TFunction } from 'i18next';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { formatSecondsToReadableForm } from '../../utils/dateRange';

type Props = {
  ooaSinceValue: number;
  timeStamp: number;
};

export const getDuration = (from: number | Date, to: number | Date, t: TFunction) =>
  formatSecondsToReadableForm(differenceInSeconds(to, from), t);

export const OutOfAdherenceDuration: React.FC<Props> = ({ ooaSinceValue, timeStamp }) => {
  const { t } = useTranslation();

  const ooASinceFormatted = useMemo(() => {
    return getDuration(new Date(ooaSinceValue), timeStamp, t);
  }, [ooaSinceValue, timeStamp, t]);

  return <>{ooASinceFormatted}</>;
};
